module.exports = __webpack_public_path__ + "img/stops_pad.84070703.svg";